/**
 * Renders the AI extracted vehicle / part data as a compact "Bento" card.
 */
const Field = ({ label, value }) => (
  <div className="min-w-0">
    <div className="text-[10px] uppercase tracking-[0.18em] text-neutral-500 font-mono-tech">
      {label}
    </div>
    <div className="text-sm text-neutral-900 font-mono-tech truncate">
      {value || <span className="text-neutral-500">—</span>}
    </div>
  </div>
);

export default function ExtractedCard({ extracted }) {
  if (!extracted) return null;
  const v = extracted.vehicle || {};
  const p = extracted.part || {};
  const intent = extracted.intent || {};
  return (
    <div
      data-testid="extracted-card"
      className="bg-neutral-50 border border-neutral-200 p-4 rise-in"
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="px-2 py-0.5 bg-[#FF5100]/10 border border-[#FF5100]/40 text-[#FF5100] text-[10px] font-bold tracking-[0.2em] font-mono-tech">
          EXTRACTED
        </span>
        <span className="text-xs text-neutral-500 truncate">{extracted.summary}</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3">
        <Field label="Make" value={v.make} />
        <Field label="Model" value={v.model} />
        <Field label="Year" value={v.year} />
        <Field label="Engine" value={v.engine} />
        <Field label="Variant" value={v.variant} />
        <Field label="VIN" value={v.vin} />
      </div>

      <div className="mt-4 pt-3 border-t border-neutral-200 grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3">
        <Field label="Part" value={p.name} />
        <Field label="OEM #" value={p.oem_number} />
        <Field label="Condition" value={p.condition_preference} />
        {(intent.location || intent.budget_zar || intent.urgency) && (
          <>
            <Field label="Location" value={intent.location} />
            <Field label="Budget (R)" value={intent.budget_zar} />
            <Field label="Urgency" value={intent.urgency} />
          </>
        )}
      </div>
    </div>
  );
}
